module.exports = __webpack_public_path__ + "static/img/draw-bg.c13f316e.png";